/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTrackingProvider.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/tracking-provider";

export class AutogenModelTrackingProvider<RowType extends ModelRow> extends Endpoint<RowType, RowTrackingProviderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTrackingProvider extends ModelRow<RowTrackingProviderFields> {
	constructor(values?: Partial<RowTrackingProviderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTrackingProviderFields {
	account_id: string;
	allow_driver_update: string;
	auth_token: string;
	auto_send: string;
	automatic_tracking: string;
	broker_recipient_id: string;
	brokerage_status_filter: string;
	bulk_carrier_upload_ran: string;
	callin_frequency: number;
	carrier_updates: string;
	client_id: string;
	client_token: string;
	company_id: string;
	dont_save_docs_to_hist: string;
	dont_send_docs_imaging: string;
	enable_billto_cust_id: string;
	enable_coop_searching: string;
	export_address: string;
	force_cancel: string;
	global_notification_setting: string;
	icc_number: string;
	id: string;
	imaging_drop_path: string;
	import_address: string;
	inbound_call_info: string;
	inbound_message_option: string;
	international_tracking: string;
	interval_minutes: number;
	is_active: string;
	is_default: string;
	is_temperature_tracking: string;
	last_carrier_upload: Date;
	last_upload_date: Date;
	load_id: string;
	log_detail_level: number;
	macropoint_requestor_id: string;
	macropoint_upload_dow: string;
	master_user: string;
	max_near_city_radius: number;
	mc_auto_dispatch: string;
	outbound_message_option: string;
	passwd: string;
	rate_conf_status_filter: string;
	require_tracking: string;
	send_email: string;
	shpmt_ident_type: string;
	track_interval_mins: string;
	tracking_duration_ext: number;
	tracking_hours_prior: number;
	tracking_url: string;
	update_next_call_time: string;
	update_partner_status: string;
	use_vendor_eta: string;
	vendor: string;
	vendor_url: string;
	version: number;
	web_password: string;
	web_username: string;
}

